<template>
    <div class="page-container">
        <div class="page-inner page-left" v-show="!isEdit">
            <div class="page-box-title title1">
                <span>
                    素材库
                </span>
                <div style="float:right;">
                    <el-input v-model="keyword" placeholder="请输入关键词" :suffix-icon="Search" @blur="handleCurrentChange(1)"></el-input>
                </div>
            </div>
            <div class="page-tab">
                <div v-for="item in tabList" :key="item.value" :class="['page-tab-item',tabActive==item.value?'page-tab-item-active':'']" @click="tabChange(item)">{{item.label}}</div>
            </div>
            <div class="page-select">
                <el-row :gutter="20" justify="center">
                    <el-col :span="8">
                        <el-dropdown max-height="350px" @command="sourceCommand">
                            <span class="el-dropdown-link">
                                {{sourceInfo.label || '来源选择'}}
                                <el-icon class="el-icon--right">
                                    <arrow-down />
                                </el-icon>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="item in sourceArr" :key="item.value" :command="item">{{item.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-col>
                    <el-col :span="8">
                        <el-dropdown max-height="350px" @command="gradeCommand">
                            <span class="el-dropdown-link">
                                {{gradeInfo.label || '年级选择'}}
                                <el-icon class="el-icon--right">
                                    <arrow-down />
                                </el-icon>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="item in gradeArr" :key="item.value" :command="item">{{item.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-col>
                    <el-col :span="8">
                        <el-dropdown @command="unitCommand">
                            <span class="el-dropdown-link">
                                {{unitInfo.label || '单元选择'}}
                                <el-icon class="el-icon--right">
                                    <arrow-down />
                                </el-icon>
                            </span>
                            <template #dropdown>
                                <el-dropdown-menu>
                                    <el-dropdown-item v-for="item in unitArr" :key="item.value" :command="item">{{item.label}}</el-dropdown-item>
                                </el-dropdown-menu>
                            </template>
                        </el-dropdown>
                    </el-col>
                </el-row>
            </div>
            <div class="history-box">
                <div class="page-inner-box empty" v-if="!tableList.length">
                    <img src="@/assets/img/empty.png" />
                    <div>暂无数据</div>
                </div>
                <template v-else>
                    <div :class="['history-box-item',detailIndex==index?'active':'']" v-for="(item,index) in tableList" :key="item.artiCorrectingId" @click="itemClick(item,index)">
                        <div class="history-box-item-top">
                            <div class="title1">
                                <!-- <el-checkbox v-model="item.checked" style="margin-right:5px;" /> -->
                                {{item.title}}
                            </div>
                            <div class="history-box-item-tag">
                                <div :class="[`classType${item.type}`]">{{typeFormat(item.type)}}</div>
                            </div>
                        </div>
                        <div class="history-box-item-inner">
                            {{item.content}}
                        </div>
                        <div class="history-box-item-bottom">
                            <div style="display:flex;">
                                <div class="history-box-bottom-icon">
                                    <el-icon size="14">
                                        <Menu />
                                    </el-icon>
                                    <span>来源：{{item.origin=='01'?'开悟作文':'其他书籍'}}</span>
                                </div>
                                <div class="history-box-bottom-icon" style="margin-left:8px;">
                                    <el-icon size="14">
                                        <StarFilled />
                                    </el-icon>
                                    <span>收藏：{{item.collectNum}}</span>
                                </div>
                            </div>
                            <div class="history-box-bottom-icon">
                                <el-icon size="14">
                                    <Clock />
                                </el-icon>
                                <span>发布：{{item.createTime}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
            <div style="text-align:center;margin-top:10px;">
                <el-config-provider :locale="zhCn" v-if="pageShow">
                    <el-pagination v-model:current-page="pageInfo.current" v-model:page-size="pageInfo.size" :total="pageInfo.total" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </el-config-provider>
            </div>
        </div>
        <div class="page-inner page-right" v-show="!isEdit">
            <div class="page-inner-box empty" v-if="!Object.keys(detailInfo).length">
                <img src="@/assets/img/empty.png" />
                <div>暂无数据</div>
            </div>
            <template v-else>
                <div class="page-box-title2 title1 source-title">
                    {{detailInfo.title}}
                    <div class="source-title-btn" @click="isEdit=true">
                        <span>Ai素材生成</span>
                    </div>
                </div>
                <div class="page-inner-box">
                    {{detailInfo.content}}
                </div>
            </template>
            <div v-if="Object.keys(detailInfo).length" class="result-footer">
                <div class="correct-tip">
                    <span class="activeColor">*</span>
                    <span>部分内容由AI生成</span>
                </div>
                <div style="display:flex;">
                    <div class="result-footer-btn" @click="collectDetailEvent">
                        <el-icon v-if="!detailInfo.isCollect" size="18">
                            <Star />
                        </el-icon>
                        <el-icon v-else color="#f9ae3d" size="18">
                            <StarFilled />
                        </el-icon>
                        <span>收藏素材</span>
                    </div>
                    <el-button color="#ef8b25" class="footer-btn1" size="small" @click="copyDetailEvent" style="float:right;">复制素材</el-button>
                </div>
            </div>
        </div>

        <!-- 编辑 -->
        <template v-if="isEdit">
            <div class="page-inner page-left">
                <div class="page-box-title title1">作文素材</div>
                <div>
                    <div class="correct-tip">
                        <span class="activeColor">*提示：</span>
                        <span>建议在输入框中输入您想写的作文标题</span>
                    </div>
                    <el-row :gutter="10" style="margin-top:10px;">
                        <el-col :span="24">
                            <el-select v-model="formData.correctGrade" placeholder="请选择学段">
                                <el-option v-for="item in pickerColumns" :key="item.value" :value="item.value" :label="item.label"></el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="10" style="margin-top:10px;">
                        <el-col :span="24">
                            <el-input maxlength="5000" v-model="formData.correctText" type="textarea" :rows="6" placeholder="输入要生成的作文素材的要求"></el-input>
                        </el-col>
                    </el-row>
                </div>
                <div style="margin:20px 0;">
                    <el-row :gutter="20">
                        <el-col :span="16">
                            <el-button :disabled="aiStart" style="width:100%" color="#ef8b25" class="footer-btn1" @click="submitEvent">AI生成作文素材</el-button>
                        </el-col>
                        <el-col :span="8">
                            <el-button style="width:100%" type="info" class="footer-btn1" @click="backEvent">返回</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-inner page-right">
                <div class="page-box-title2 title1" v-if="!Object.keys(resultInfo).length">作文素材生成结果</div>
                <div class="page-box-correct" v-if="Object.keys(resultInfo).length">
                    <el-tabs v-model="activeName" class="demo-tabs" @tab-change="resultTabChange">
                        <el-tab-pane :label="item.label" :name="item.value" :key="item.value" v-for="item in resultTabList"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="source-inner" v-if="activeName in resultInfo && resultInfo[activeName].length">
                    <div class="source-inner-checkAll">
                        <el-checkbox v-model="checkAll" @change="handleCheckAllChange">
                            全选素材
                        </el-checkbox>
                        <div @click="transVoice" class="source-inner-voice">
                            <el-icon>
                                <Microphone />
                            </el-icon>
                            <span v-if="voiceStatus==2">语音继续</span>
                            <span v-else-if="voiceStatus==1">语音暂停</span>
                            <span v-else-if="voiceStatus==4">语音重播</span>
                            <span v-else>转语音</span>
                        </div>
                    </div>
                    <div style="padding:10px;">
                        <div v-for="(item,index) in resultInfo[activeName]" :key="item.id">
                            <el-checkbox v-model="item.checked" @change="(val)=>handleCheckedChange(val,index)">
                                {{ item.title }}
                            </el-checkbox>
                            <div class="result-content" @click="handleCheckedChange(!item.checked,index)">{{ item.content }}</div>
                        </div>
                    </div>
                </div>
                <div class="page-inner-box empty" v-if="!Object.keys(resultInfo).length">
                    <img src="@/assets/img/empty.png" />
                    <div>结果将在此处展示！</div>
                </div>
                <div v-if="Object.keys(resultInfo).length" class="result-footer">
                    <div class="correct-tip">
                        <span class="activeColor">*</span>
                        <span>部分内容由AI生成</span>
                    </div>
                    <div style="display:flex;">
                        <div class="result-footer-btn" @click="collectEvent">
                            <el-icon>
                                <Star />
                            </el-icon>
                            <span>收藏素材</span>
                        </div>
                        <el-button color="#ef8b25" class="footer-btn1" size="small" :disabled="aiStart" @click="copyEvent" style="float:right;">复制素材</el-button>
                    </div>
                </div>
            </div>
        </template>

        <AIpopup v-if="popupShow" :popupShow="popupShow" :cancelShow="false" @cancel="aiCancel"></AIpopup>
    </div>
</template>
<script lang="ts" setup>
import clipBoard from "vue-clipboard3"
import { ref, reactive, onMounted, onBeforeUnmount, nextTick } from 'vue';
import { compMaterialStreamingV2, saveSreamResult, checkAiCall, getPubMaterial, materialGrade, materialUnit, materialCollectAi, materialUnCollect, materialCollect, getMaterialDetail, getVoiceDataOss } from "@/api/composition.js"
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import AIpopup from "./components/AIpopup.vue";
import { formatterEvent } from "@/utils/common.js"
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import { Search } from '@element-plus/icons-vue'
import Speech from 'speak-tts'
import { useStore } from "vuex"
const store = useStore();
let { toClipboard } = clipBoard()

const speech = new Speech();

// 列表
const isEdit = ref(false)
const tabActive = ref('all')
const keyword = ref('')
const tableList = ref([])
const pageInfo = ref({
    current: 1,
    size: 10,
    total: 10
})
const pageShow = ref(true)
const detailInfo = ref({})
const detailIndex = ref(0)
const gradeArr = ref([])
const unitArr = ref([])
const sourceInfo = ref({})
const gradeInfo = ref({})
const unitInfo = ref({})

const tabList = [
    {
        label: '全部',
        value: 'all'
    },
    {
        label: '热门词汇',
        value: '01'
    },
    {
        label: '优秀句式',
        value: '02'
    },
    {
        label: '精彩段落',
        value: '03'
    },
]
const sourceArr = [
    {
        label: '全部',
        value: ''
    },
    {
        label: '开悟作文',
        value: '01'
    }, {
        label: '其他书籍',
        value: '02'
    }
]


function tabChange(item) {
    if (item.value == tabActive.value) return
    tabActive.value = item.value
    handleCurrentChange(1)
}

function getList() {
    const params = {
        current: pageInfo.value.current,
        size: pageInfo.value.size,
        type: tabActive.value == 'all' ? '' : tabActive.value,
        grade: gradeInfo.value.value,
        origin: sourceInfo.value.value,
        unit: unitInfo.value.value,
        title: keyword.value,
    }
    pageInfo.value.total = 0;
    tableList.value = []
    getPubMaterial(params).then((res: any) => {
        tableList.value = (res.data.records || []).map(item => {
            return {
                ...item,
                checked: false
            }
        })
        pageInfo.value.total = res.data.total || 0;
        if (tableList.value.length) {
            itemClick(tableList.value[0], 0)
        } else {
            detailInfo.value = {}
            detailIndex.value = 0
        }
    })
}

function typeFormat(val) {
    return formatterEvent(tabList, val)
}

function handleSizeChange(val) {
    pageInfo.value.size = val;
    getList()
}
function handleCurrentChange(val) {
    pageInfo.value.current = val;
    pageShow.value = false;
    getList()
    nextTick(() => {
        pageShow.value = true;
    })
}

function itemClick(item, index) {
    detailIndex.value = index
    getMaterialDetail({ type: 2, id: item.id }).then(res => {
        detailInfo.value = res.data;
    })
}

function sourceCommand(item) {
    if (sourceInfo.value.value == item.value) return;
    gradeInfo.value = {}
    unitInfo.value = {}
    if (item.label == '全部') {
        sourceInfo.value = {
            label: '来源选择',
            value: ''
        }

    } else {
        sourceInfo.value = item;
        if (item.value == '01') {
            materialGrade().then(res => {
                let arr = (res.data || []).map(info => {
                    return {
                        label: info,
                        value: info
                    }
                })
                gradeArr.value = [
                    {
                        label: '全部',
                        value: ''
                    },
                    ...arr,
                ]
            })
        }
    }
    handleCurrentChange(1)
}

function gradeCommand(item) {
    if (gradeInfo.value.value == item.value) return;
    unitInfo.value = {}
    if (item.label == '全部') {
        gradeInfo.value = {
            label: '年级选择',
            value: ''
        }
    } else {
        gradeInfo.value = item;
        materialUnit(item.value).then(res => {
            let arr = (res.data || []).map(info => {
                return {
                    label: info,
                    value: info
                }
            })
            unitArr.value = [
                {
                    label: '全部',
                    value: ''
                },
                ...arr,
            ]
        })
    }
    handleCurrentChange(1)
}

function unitCommand(item) {
    if (unitInfo.value.value == item.value) return;
    if (item.label == '全部') {
        unitInfo.value = {
            label: '年级选择',
            value: ''
        }
    } else {
        unitInfo.value = item;
    }
    handleCurrentChange(1)
}

function collectDetailEvent() {
    const api = detailInfo.value.isCollect ? materialUnCollect : materialCollect;
    api(detailInfo.value.id).then(res => {
        ElMessage.success(detailInfo.value.isCollect ? '取消收藏' : '收藏成功')
        getList()
    })
}

onMounted(() => {
    getList()


    speech.init({
        volume: 1,
        lang: 'zh-CN',
        rate: 1.4,
        pitch: 1.4,
    }).then(() => {
        console.log('语音引擎初始化成功');
    });
})





// 编辑
const pickerColumns = [
    {
        label: '小学',
        value: '小学'
    },
    {
        label: '初中',
        value: '初中'
    },
    {
        label: '高中',
        value: '高中'
    }
]
const resultTabList = [
    {
        label: '好词',
        value: 'ci'
    },
    {
        label: '好句',
        value: 'ju'
    },
    {
        label: '好段',
        value: 'duan'
    },
]

const formData = ref({
    correctText: '',
    correctGrade: ''
})
let controller = null
let resultInfo = ref({})
let timeFlag = 0
const romanNumerals = ["Ⅰ", "Ⅱ", "Ⅲ", "Ⅳ", "Ⅴ", "Ⅵ", "Ⅶ", "Ⅷ", "Ⅸ", "Ⅹ"];
let resultNum = {}, currentKey = '', regex = new RegExp(`(${romanNumerals.join('|')})|([^${romanNumerals.join('')}]+)`, 'g');
const aiStart = ref(false)
const popupShow = ref(false)
const checkAll = ref(false)
const activeName = ref('ci')
const voiceStatus = ref(0) //1 语音正在播放 2语音暂停 0没有语音 4语音播放完成
let musicContext = new Audio()
function aiCancel() {
    aiStart.value = false;
    popupShow.value = false;
    controller && controller.abort()
}
function submitEvent() {
    const { correctText, correctGrade } = formData.value;
    if (!correctText) {
        return ElMessage.warning('请填写素材要求');
    }
    if (!correctGrade) {
        return ElMessage.warning('请选择学段');
    }
    checkAiCall().then(res => {
        if (res.data.result) {
            ElMessageBox.confirm(
                `今日AI调用频繁，已超过${res.data.num}次`,
                '温馨提示',
                {
                    confirmButtonText: '继续用',
                    type: 'warning',
                    showCancelButton: false
                }
            ).then(() => {
                getAi()
            })
        } else {
            getAi()
        }
    })

}

function backEvent() {
    isEdit.value = false
    resultInfo.value = {}
    formData.value = {
        correctText: '',
        correctGrade: ''
    }
    voiceStatus.value = 0;
}

function getAi() {
    const { correctText, correctGrade } = formData.value;
    const params = {
        grade: correctGrade,
        term: '',
        title: correctText,
    }
    aiStart.value = true
    popupShow.value = true
    voiceStatus.value = 0;
    fetchRequest({
        url: compMaterialStreamingV2,
        aiParam: params,
        timeFlag: new Date().getTime()
    })
}

async function fetchRequest(params) {
    if (timeFlag == params.timeFlag) return;
    timeFlag = params.timeFlag;
    controller = new AbortController()
    resultInfo.value = {}
    resultNum = {}
    currentKey = ''
    const { signal } = controller;
    const response = await fetch(params.url, {
        signal,
        method: 'POST',
        headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem("token"),
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params.aiParam)
    })
    popupShow.value = false
    if (!response.ok) {
        try {
            const errorData = await response.join()
            aiStart.value = false
            return ElMessage.warning(errorData.message || '请求失败')
        } catch (error) {
            console.log(error)
            aiStart.value = false
            return ElMessage.warning('请求失败')
        }
    }

    const reader = response.body.getReader()
    const decoder = new TextDecoder('utf-8')
    let done = false;
    let obj = {}
    let str = ''
    while (!done) {
        const {
						done: readerDone,
            value
					} = await reader.read()
        done = readerDone;

        if (value) {
            const chunkText = decoder.decode(value, {
                stream: !done
            })
            const chunkInfo = JSON.parse(chunkText)
            console.log(chunkInfo)
            let obj = {}
            for (let key in chunkInfo.data) {
                const arr = chunkInfo.data[key];
                obj[key] = []
                let info = [],
                    num = 0;
                arr.forEach(item => {
                    const textArr = item.text;
                    textArr.forEach(textItem => {
                        const index = textItem.indexOf('：')
                        let textObj = {}
                        if (index > -1) {
                            const textStr = textItem.split('：')
                            textObj.title = textStr[0];
                            textObj.content = textStr[1];
                            if (key == 'ci') {
                                textObj.id = 'ci_' + num;
                            } else if (key == 'ju') {
                                textObj.id = 'ju_' + num;
                            } else if (key == 'duan') {
                                textObj.id = 'duan_' + num;
                            }
                        } else {
                            if (key == 'ci') {
                                textObj.title = '其他类词语';
                                textObj.id = 'ci_' + num;
                            } else if (key == 'ju') {
                                textObj.title = '其他类句';
                                textObj.id = 'ju_' + num;
                            } else if (key == 'duan') {
                                textObj.title = '其他类段落';
                                textObj.id = 'duan_' + num;
                            }
                            textObj.content = textItem;
                        }
                        num++;
                        textObj.checked = false;
                        obj[key].push(textObj)
                    })
                })
            }
            resultInfo.value = obj;
        } else {
            aiStart.value = false;
        }
    }
}

async function copyEvent() {
    try {
        const checkList = resultInfo.value[activeName.value].filter(item => {
            return item.checked
        })
        if (!checkList || !checkList.length) {
            return ElMessage.warning('请选择想收藏的词句段！')
        }
        let text = ''
        checkList.forEach(item => {
            text = text + item.content + '\n'
        })
        await toClipboard(text)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}

async function copyDetailEvent() {
    try {
        let text = ''
        let obj = detailInfo.value
        if (Object.keys(obj).length) {
            text = obj.content
        }
        await toClipboard(text)
        ElMessage.success('复制成功')
    } catch{
        ElMessage.error('复制失败')
    }
}

function collectEvent() {
    let obj = {
        'ci': [],
        'ju': [],
        'duan': []
    }
    const checkList = resultInfo.value[activeName.value].filter(item => {
        return item.checked
    })
    if (!checkList || !checkList.length) {
        return ElMessage.warning('请选择想收藏的词句段！')
    }
    checkList.forEach(item => {
        obj[activeName.value].push(item)
    })
    materialCollectAi(obj).then(res => {
        ElMessage.success('收藏成功')
    })

}

function handleCheckAllChange(val) {
    resultInfo.value[activeName.value].map(item => {
        item.checked = val
        return item
    })
    checkAll.value = val
}

function handleCheckedChange(val, index) {
    resultInfo.value[activeName.value][index].checked = val
    const len = resultInfo.value[activeName.value].length;
    let checkLen = 0;
    resultInfo.value[activeName.value].forEach(item => {
        if (item.checked) {
            checkLen++
        }
    })
    if (checkLen > 0 && checkLen == len) {
        checkAll.value = true
    } else {
        checkAll.value = false
    }
}

function resultTabChange(val) {
    resultInfo.value[activeName.value].map(item => {
        item.checked = false
        return item
    })
    checkAll.value = false
    activeName.value = val;
    speech.cancel()
    voiceStatus.value = 0
}

function transVoice() {
    if (aiStart.value) {
        return ElMessage.warning('独家算法，请稍等！');
    }
    if (voiceStatus.value == 1) {
        speech.pause()
        voiceStatus.value = 2
        return
    }
    if (voiceStatus.value == 2) {
        speech.resume()
        voiceStatus.value = 1
        return
    }
    if (Object.keys(resultInfo.value).length) {
        let text = ''
        const loading = ElLoading.service({
            lock: true,
            text: '语音即将播放！',
            background: 'rgba(255, 255, 255, 0.7)',
        })
        resultInfo.value[activeName.value].map(item => {
            text += `${item.title}\n`
            text += `${item.content}\n`
        })
        speech.speak({
            text: text,
            listeners: {
                onstart: () => {
                    loading.close()
                    voiceStatus.value = 1;
                },
                onend: () => {
                    voiceStatus.value = 4
                }
            }
        });
    }
}

onBeforeUnmount(() => {
    controller && controller.abort()
    speech && speech.cancel()
})
</script>
<style lang="scss" scoped>
@import "@/style/variable.scss";
.correct-title {
    font-size: 12px;
    color: $base-text-color;
    line-height: 1.8;
    margin: 20px 0;
}

.page-container {
    .page-box-title {
        line-height: unset;
    }
    .page-inner.page-left {
        background: rgba(255, 255, 255, 0.4);
    }
}

.correct-tip {
    font-size: 12px;
    margin: 10px 0;
    color: #999;
}

.result-content {
    line-height: 1.4;
    margin-left: 21px;
    font-size: 14px;
}

.upload-box {
     ::v-deep .el-upload-list--picture-card {
        --el-upload-list-picture-card-size: 120px;
    }
     ::v-deep .el-upload--picture-card {
        --el-upload-picture-card-size: 120px
    }
    .upload-inner {
        text-align: center;
        color: #ccc;
    }
}

.page-box-correct {
    position: relative;
     ::v-deep .el-tabs__item.is-active,
     ::v-deep .el-tabs__item:hover {
        color: $base-color;
    }
     ::v-deep .el-tabs__active-bar {
        background-color: $base-color;
    }
}

.source-title {
    display: flex;
    justify-content: space-between;
    .source-title-btn {
        font-weight: normal;
        cursor: pointer;
    }
}

.page-tab {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    width: 100%;
    .page-tab-item {
        flex: 1;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background: #fff;
        border-radius: 6px;
        cursor: pointer;
    }
    .page-tab-item-active {
        background: $base-color;
        color: #fff;
    }
    .page-tab-item+.page-tab-item {
        margin-left: 20px;
    }
}

.history-box {
    height: calc(100% - 190px);
    overflow-y: auto;
    .history-box-item {
        padding: 20px 15px;
        background: #fff;
        border-radius: 10px;
        &.active {
            border: 1px solid $base-color;
        }
        .history-box-item-top {
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid $base-border-color;
            padding: 0 15px 10px;
            align-items: center;
            .title1 {
                display: flex;
                align-items: center;
            }
        }
        .history-box-item-tag {
            display: flex;
            &>div {
                padding: 3px 8px;
                color: #fff;
                border-radius: 6px;
                font-size: 12px;
            }
            &>div+div {
                margin-left: 8px;
            }
            .classType01 {
                color: #c63848;
                background: linear-gradient(#ffd0db, #fef3f1);
            }

            .classType03 {
                color: #686ecc;
                background: linear-gradient(#dad3ff, #eff1fe);
            }

            .classType02 {
                color: #cb5903;
                background: linear-gradient(#ffd8b9, #ffebe2);
            }
        }
        .history-box-item-inner {
            margin: 10px 15px;
            font-size: 14px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 24px;
        }
        .history-box-item-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px 0;
            color: #666;
            font-size: 12px;
            .history-box-bottom-icon {
                display: flex;
                align-items: center;
                &>i+span {
                    margin-left: 5px;
                }
            }
        }
    }
    .history-box-item+.history-box-item {
        margin-top: 15px;
    }
}

.page-select {
    padding: 10px 0;
    text-align: center;
    width: 100%;
    font-size: 16px;
    font-weight: bold;
    background: #ffff;
    margin-bottom: 10px
}

.result-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .result-footer-btn {
        margin-right: 10px;
        font-size: 12px;
        padding: 4px 11px;
        box-sizing: border-box;
        cursor: pointer;
        display: flex;
    }
}

.page-inner-box {
    height: calc(100% - 91px);
}

.source-inner {
    height: calc(100% - 91px);
    background: #eee;
    line-height: 28px;
    border: 1px solid #eee;
    margin: 10px 0;
    border-radius: 10px;
    overflow-y: auto;
    box-sizing: border-box;
    .source-inner-checkAll {
        padding: 10px;
        background: #f9e7ce;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .source-inner-voice {
            font-size: 12px;
            background: #fff;
            text-align: center;
            border-radius: 13px;
            color: #ef8b25;
            cursor: pointer;
            width: 80px;
            text-align: center;
            height: 24px;
            line-height: 24px;
        }
    }
}
</style>
